var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "394B4BD0-DAB8-48A4-9300-1B64B99E1D6C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "null",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in-/-sign-up--7",
    transform: "translate(-601.000000, -349.000000)",
    fill: "#3AD42F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(100.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15102",
    transform: "translate(0.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-tick-801900",
    transform: "translate(501.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2260247,0.0122427818 C8.09623161,0.0122427818 0.689040988,7.4194334 0.689040988,16.5492265 C0.689040988,25.6790196 8.09623161,33.0862102 17.2260247,33.0862102 C26.3558178,33.0862102 33.7630084,25.6790196 33.7630084,16.5492265 C33.7630084,7.4194334 26.3558178,0.0122427818 17.2260247,0.0122427818 Z M25.7356809,12.5527888 L16.020203,22.3027187 C15.7101899,22.6127318 15.2622579,22.8194011 14.8142582,22.8194011 C14.3662585,22.8194011 13.9185664,22.6470916 13.6083134,22.3027187 L8.7163685,17.4105277 C8.02738903,16.7215483 8.02738903,15.6535347 8.7163685,14.9643092 C9.40534797,14.2753297 10.4733615,14.2753297 11.1625871,14.9643092 L14.8144428,18.6161649 L23.324099,10.1065087 C24.0130784,9.41752923 25.081092,9.41752923 25.7703175,10.1065087 C26.4247219,10.7957342 26.4247219,11.8636863 25.7357117,12.5527272 L25.7356809,12.5527888 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.551df3477ff35f8ae4f1be5229df3342.svg";
export { ForwardRef as ReactComponent };